import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { WorkBatch, WorkBatchSegment, WorkBatchSegmentState } from '../work-batch'
import { BehaviorSubject } from 'rxjs'
import { WorkTransferState } from '../../work-items/work-item'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-batch-line',
  templateUrl: './work-batch-line.component.html',
  styleUrls: ['./work-batch-line.component.scss'],
  imports: [MatTooltip, MatIcon, AsyncPipe, ElderTranslatePipe],
})
export class WorkBatchLineComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly batch$ = new BehaviorSubject<WorkBatch>(null)

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set batch(batch: WorkBatch) {
    this.batch$.next(batch)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public segmentIcon(segment: WorkBatchSegment): string {
    switch (segment.state) {
      case WorkBatchSegmentState.OPEN:
        return 'radio_button_unchecked'
      case WorkBatchSegmentState.PROCESSING:
        return this.segmentIconByTransferState(segment.transferState)
      case WorkBatchSegmentState.COMPLETED:
        return 'check_circle_outline'
      default:
        return 'help_outline'
    }
  }

  public getToolTipTranslation(segment: WorkBatchSegment): string {
    switch (segment.state) {
      case WorkBatchSegmentState.OPEN:
        return `WorkBatchSegmentState.${WorkBatchSegmentState.OPEN}`
      case WorkBatchSegmentState.PROCESSING:
        return this.getTransferStateTranslation(segment.transferState)
      case WorkBatchSegmentState.COMPLETED:
        return `WorkBatchSegmentState.${WorkBatchSegmentState.COMPLETED}`
      default:
        return `WorkBatchSegmentState.${WorkBatchSegmentState.UNKNOWN}`
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private segmentIconByTransferState(transferState: WorkTransferState): string {
    switch (transferState) {
      case WorkTransferState.OPEN:
        return 'play_circle_outline'
      case WorkTransferState.FAILED:
        return 'file_download_off'
      case WorkTransferState.SENDING:
        return 'file_download'
      case WorkTransferState.CONFIRMED:
        return 'file_download'
    }
  }

  private getTransferStateTranslation(transferState: WorkTransferState) {
    switch (transferState) {
      case WorkTransferState.OPEN:
        return 'workBatches.segment.transfer.open'
      case WorkTransferState.FAILED:
        return 'workBatches.segment.transfer.failed'
      case WorkTransferState.SENDING:
        return 'workBatches.segment.transfer.sending'
      case WorkTransferState.CONFIRMED:
        return 'workBatches.segment.transfer.confirmed'
    }
  }
}
